/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createContext, type Context, type Ref } from 'react';

export const DraggableRefContext: Context<Ref<HTMLElement> | undefined> = createContext<
	Ref<HTMLElement> | undefined
>(undefined);
